import React, { useEffect, useState, useRef } from "react";
import { buildImageURLs } from "./api/imageService";

const Modal = require("react-modal");

// Set app element only if #root exists (to avoid issues in tests)
const rootElement = document.getElementById("root");
if (rootElement) {
  Modal.setAppElement("#root");
}

interface PortraitsBlackAndWhiteProps {
  rows?: number;
}

export const PortraitsBlackAndWhite: React.FC<PortraitsBlackAndWhiteProps> = ({
  rows: _rows = 3,
}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [images, setImages] = useState<string[]>([]);
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [imageClass, setImageClass] = useState<string>("");

  const galleryRef = useRef<HTMLDivElement>(null);

  const openModal = (image: string) => {
    setSelectedImage(image); // Use the original image directly
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setModalIsOpen(false);
    setImageClass("");
  };

  const handleImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const { naturalWidth, naturalHeight } = e.currentTarget;
    if (naturalWidth > naturalHeight) {
      setImageClass("modal-image landscape");
    } else {
      setImageClass("modal-image portrait");
    }
    e.currentTarget.classList.add("loaded");
  };

  useEffect(() => {
    const fetchImages = async () => {
      const fetchedImages = await buildImageURLs(
        "portraits-black-and-white",
        13
      );
      setImages(fetchedImages);
    };

    fetchImages();
  }, []);

  useEffect(() => {
    const useVerticalScroll = (event: WheelEvent) => {
      if (event.deltaY !== 0) {
        event.preventDefault();
        if (galleryRef.current) {
          galleryRef.current.scrollLeft += event.deltaY * 2; // Increase scroll speed
        }
      }
    };

    document.addEventListener("wheel", useVerticalScroll, { passive: false });
    return () => {
      document.removeEventListener("wheel", useVerticalScroll);
    };
  }, []);

  // Helper for rendering image thumbnails
  const renderImageThumbnail = (image: string, imageIndex: number) => (
    <img
      key={imageIndex}
      src={image}
      alt={`portrait ${imageIndex}`}
      style={{ height: "500px" }}
      onClick={() => openModal(image)}
      onLoad={handleImageLoad}
    />
  );

  return (
    <div className="page-container-gallery">
      <div className="horizontal-gallery-container">
        <div className="horizontal-gallery" ref={galleryRef}>
          {images.map((image, index) => renderImageThumbnail(image, index))}
          <Modal
            isOpen={modalIsOpen}
            className="modal"
            overlayClassName="overlay"
            shouldCloseOnOverlayClick={true}
            onRequestClose={closeModal}
            shouldCloseOnEsc={true}
          >
            {selectedImage && (
              <img
                src={selectedImage}
                alt="Selected"
                className={imageClass}
                onLoad={handleImageLoad}
                onClick={closeModal}
              />
            )}
          </Modal>
        </div>
      </div>
    </div>
  );
};
